<template>
  <Offcanvas name="dataProviderCreateOffcanvas">
    <template v-slot:header>
      <h4>{{ $t('data_providers.form.title') }}</h4>
    </template>
    <template v-slot:default>
      <form @submit.prevent="create">
        <DataProviderForm v-model="newDataProvider"/>
        <div class="mt-3">
          <button class="btn btn-primary w-100">{{ $t('data_providers.form.register_button') }}</button>
        </div>
        <div class="mt-2">
          <small class="text-muted">
            {{ $t('data_providers.form.create_note') }}
          </small>
        </div>
      </form>
    </template>
  </Offcanvas>
</template>

<script setup>
import {ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {createDataProvider} from '../../../api/admin/DataProviderApi';
import Offcanvas from '../../../components/Offcanvas.vue';
import useFlashMessage from '../../../composables/useFlashMessage';
import useOffcanvas from '../../../composables/useOffcanvas';
import DataProvider from '../../../models/DataProvider';
import DataProviderForm from './DataProviderForm.vue';

const emit = defineEmits(['create']);

const {t} = useI18n();
const {successMessage, errorMessage} = useFlashMessage();
const {closeOffcanvas} = useOffcanvas('dataProviderCreateOffcanvas');

const newDataProvider = ref(new DataProvider);

/**
 * Create a new data provider
 *
 * @returns {Promise<void>}
 */
const create = async () => {
  try {
    const data = await createDataProvider(newDataProvider.value);
    successMessage(t('data_providers.messages.created', { name: data.name }));
    newDataProvider.value = new DataProvider;
    emit('create');
    closeOffcanvas();
  } catch (e) {
    if (e.status === 403) {
      // Do nothing
    } else {
      errorMessage(e.message);
    }
  }
};
</script>